module.exports = __webpack_public_path__ + "static/scale-model-of-public-art-\"interlude\"-in-long-beach-california-1e993b134b2fa7669013d2322e87b55d.png";